import type { ShippingPosition } from './types';
import { formatMoney } from './formatMoney';

/**
 * The pre-checkout fee rows shown before a delivery address exists: shipping
 * fee + sales tax can't be quoted without an address (muted "TBD at
 * Checkout"), and the flat handling fee is backend-sourced (a muted "…"
 * placeholder until it loads). Shared by the reveal Create Shipping modal and
 * the MyPacks ship Disclaimer so the two stay byte-identical.
 */
export function buildPreCheckoutPositions(handlingFee: number | null): ShippingPosition[] {
  return [
    { label: 'Shipping fee', value: 'TBD at Checkout', muted: true },
    { label: 'Sales tax', value: 'TBD at Checkout', muted: true },
    handlingFee != null
      ? { label: 'Handling fee', value: formatMoney(handlingFee) }
      : { label: 'Handling fee', value: '…', muted: true },
  ];
}
